<template id="Login">
  <v-ons-page id="LoginPage">
    <v-ons-row>
      <v-ons-col class="containerLogin">
         <v-ons-toolbar>
        <div class="left">
          <img width="168px" src="../assets/img/logoQR.png" />
        </div>
        <div class="center"></div>
      </v-ons-toolbar>

        <div style="margin-top: auto !important; max-width: 480px; text-transform: none;">
            <h3 class="entrar">LOGIN</h3>
            <h3 class="textoCPF">Insira seus dados para continuar</h3>

            <v-ons-input
            type="email"
            style="margin-bottom: 10px; background: #fff"
            placeholder="E-mail"
            float
            v-model="input.email"
            ></v-ons-input>
            <v-ons-input
            style="margin-bottom: 0px; background: #fff"
            v-on:keyup.enter="makeLogin()"
            placeholder="Senha"
            type="password"
            float
            v-model="input.pass"
            ></v-ons-input>

            <p>
            <a @click="dialogEsqueceuSenha = true">
                Esqueceu a senha? Clique aqui</a
            >
            </p>

            <p>
              <router-link to='/Cadastro' style="color: transparent;">
                <a> Ainda não tem uma conta? Clique aqui</a>
              </router-link>
            </p>

            <v-ons-button class="botao" @click="makeLogin()">Entrar</v-ons-button>
        </div>

        <p style="margin-top: auto !important; min-width: 850px;">
            Copyright © 2020. Todos os direitos reservados a Cyma Digital. leia aqui os<a href="https://qrservice.com.br/termos-de-uso" target="_blank" style="border-bottom: 0px;"> termos e condições.</a>
        </p>
      </v-ons-col>
    </v-ons-row>
    <v-ons-dialog
      class="dialogEsqueceuSenha"
      cancelable
      :visible.sync="dialogEsqueceuSenha"
    >
      <v-ons-row>
        <v-ons-col>
          <h2>Esqueci a Senha</h2>
          <v-ons-row>
            <v-ons-col>
              <v-ons-label for="dsEmail">Email: </v-ons-label>
              <v-ons-input
                type="text"
                input-id="dsEmail"
                v-model="dsEmail"
                placeholder="email"
              />
            </v-ons-col>
          </v-ons-row>
          <v-ons-row>
            <v-ons-col style="text-align: center">
              <v-ons-button class="botao" @click="resetarSenha()"
                >Enviar</v-ons-button
              >
            </v-ons-col>
          </v-ons-row>
        </v-ons-col>
      </v-ons-row>
    </v-ons-dialog>
  </v-ons-page>
</template>
<style >
#LoginPage .containerLogin {
    height: 93vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 800px;
}

#LoginPage .page__background {
  background-color: #5b5b5b;
  background-image: url('../assets/img/Bg_QR.png');
  background-size: cover; 
  background-position: right;
}
.entrar {
  font-size: 45px !important;
  font-weight: normal !important;
}

.facalogin {
  font-size: 20px;
  margin: 60px !important;
}

ons-input {
  display: inline-block;
  position: relative;
  width: 86%;
  margin-left: 30px;
  margin-right: 30px;
  padding: 3px;
  border-radius: 5px;
}
ons-input .text-input,
ons-search-input .search-input {
  width: 100%;
  display: inline-block;
  height: 40px;
}

.text-input--material__label--active {
  display: none;
}
#LoginPage .page--material__content h3 {
  font-weight: normal !important;
}

#LoginPage .list-item--material {
  border: 0;
  padding: 0 0 0 30px;
  line-height: normal;
}
#LoginPage .list-item--material__left {
  padding: 14px 0;
  min-width: 34px;
  line-height: 1;
  min-height: 48px;
}
#LoginPage a {
  color: #ffff;
  border-bottom: 1px solid #fff;
  text-decoration: none;
}
#LoginPage p {
  margin: 0 !important;
  margin-top: 15px !important;
}

#LoginPage .botao {
  background-color: #5b5b5b !important;
  color: #fff !important;
}

#LoginPage .list-item--material__center {
  background: none !important;
}
#LoginPage .text-input--material__label {
  font-family: "DMSans-Regular";
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  color: #afafaf;
  position: absolute;
  left: 2px;
  top: 2px;
  font-size: 18px;
  font-weight: 400;
  pointer-events: none;
  /* height: 66px; */
  padding-top: 4px;
}
.dialogEsqueceuSenha h2 {
  color: #000;
  text-align: center;
}
.dialogEsqueceuSenha ons-input {
  background-color: #fff;
  width: 50%;
  border-radius: 5px;
  border-bottom: 1px solid #999999;
}

.dialogEsqueceuSenha v-ons-label {
  margin-left: 15px;
  min-width: 50px;
  display: inline-flex;
  justify-content: flex-end;
  text-align: right;
}
</style>
<script>
// import Home from "./Home.vue";
import Cadastro from "./FormCadastro.vue";
export default {
  name: "Login",
  key: "Login",
  props: ["pageStack"],
  data() {
    return {
      input: {
        email: "",
        pass: "",
      },
      dsEmail: "",
      dialogEsqueceuSenha: false,
    };
  },
  methods: {
    resetarSenha() {
      if (this.dsEmail != "") {
        var strEmail = btoa(this.dsEmail);
        fetch(this.$menu_uri + "/rst-password/" + strEmail, { method: "GET" })
          .then((response) => response.json())
          .then((data) => {
            // window.console.log(data)
            if (data.send > 0) {
              this.$ons.notification.toast(
                "Um email foi encaminhado com as instruções a seguir!",
                { timeout: 1000, animation: "ascend" }
              );
              this.dialogEsqueceuSenha = false;
            } else {
              this.$ons.notification.toast("Email não encontrado!", {
                timeout: 1000,
                animation: "ascend",
              });
            }
          })
          .catch((error) => {
            if (error) {
              this.$ons.notification.toast("Erro de rede, tente novamente! ", {
                timeout: 1000,
                animation: "ascend",
              });
            }
          });
      } else {
        this.$ons.notification.toast("Por favor preencha um email! ", {
          timeout: 1000,
          animation: "ascend",
        });
      }
    },
    makeLogin() {
      if (this.input.email != "" && this.input.pass != "") {
        fetch(this.$menu_uri + "/login", {
          method: "OPTIONS",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.input),
        })
          .then((response) => response.json())
          .then((data) => {
            fetch(this.$menu_payment_uri + "/public/login", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: this.input.email,
                password: this.input.pass,
              }),
            })
              .then((response) => response.json())
              .then((dataPayment) => {
                if (data.idEstabelecimento) {
                  this.input.email = "";
                  this.input.pass = "";
                  localStorage.setItem("e", JSON.stringify(data));
                  localStorage.setItem("qrservice_token", dataPayment.token);
                  localStorage.setItem(
                    "qrservice_refresh_token",
                    dataPayment.refreshToken
                  );
                  // this.$emit("change-e", data);
                  localStorage.setItem("makeLogin", true);
                  this.$router.push('/Home');
                } else {
                  this.$ons.notification.toast(
                    "Combinação Email e Senha inválida! ",
                    { timeout: 1000, animation: "ascend" }
                  );
                }
              })
              .catch((error) => {
                this.$ons.notification.toast(
                  "Ocorreu um erro, por favor tente novametne! ",
                  { timeout: 1000, animation: "ascend" }
                );
                localStorage.setItem("fetchErr", error);
              });
          })
          .catch((error) => {
            this.$ons.notification.toast(
              "Ocorreu um erro, por favor tente novametne! ",
              { timeout: 1000, animation: "ascend" }
            );
            localStorage.setItem("fetchErr", error);
          });
      } else {
        this.$ons.notification.toast("Por favor insira um Email e uma Senha!", {
          timeout: 1000,
          animation: "ascend",
        });
      }
    },
    openCadastro() {
      this.$emit("push", Cadastro);
    },
    back() {
      this.$emit("pop");
    },
  },
};
</script>